/* eslint no-console: 0 */

import Vue from 'vue/dist/vue.esm';

document.addEventListener('DOMContentLoaded', () => {
  var messageApp = new Vue({
    el: '#userSignIn',
    data: {
      show_alert_modal: true,
      // hide_modal: false
    },
  });
});
